import { CDN_URL_DOMAIN, COS_URL_DOMAIN } from '@intelligence/_config/config';
import moment from 'moment';
import { history } from 'umi';

/**
 * @description: 转换timeList格式为{ text: item, value: item }
 * @param {*} timeList
 * @return {*}
 */
export const getTimeListArray = (timeList: {}) => {
  const verList = Object.keys(timeList);
  const segmentlist: { text: string; value: string }[] = [];
  timeList.forEach((item, index) => {
    const dateFormat = moment(new Date(item)).format('YYYY-MM-DD');
    segmentlist.push({ text: item, value: item });
  });
  return segmentlist;
};

/**
 * @description: 设置图片参数
 * @param {*} selectedIdx
 * @param {*} selectedTimeList
 * @param {*} selectedDate
 * @return {*}
 */
export const getImgList = (selectedIdx, selectedTimeList, selectedDate, imgInfo) => {
  const imgList = [];
  if (selectedTimeList?.length > 0) {
    const info = imgInfo?.[selectedDate || selectedTimeList[0]] || {};
    for (let i = 1; i <= Number(info?.length); i++) {
      let url = `${info?.cos_path}/${i}.${info?.img_type}`;
      // 替换 cos 链接资源为 cdn 地址
      url = url.replace(COS_URL_DOMAIN, CDN_URL_DOMAIN);
      imgList.push(url);
    }
    changeURLStatic(selectedIdx, selectedDate || selectedTimeList[0]);
  } else {
    history.push('/intelligence/reports/trendingGames');
  }

  return imgList;
};

/**
 * @description: 静态改变Url 不刷新页面
 * @param {*} uid
 * @param {*} ver
 * @return {*}
 */
const changeURLStatic = (uid, ver) => {
  // console.log("test")
  // let url =  `${location.origin}/v2/intelligence/reports/trendingGames/${uid}/${ver}`
  // history.replaceState(null, null, url);
  const url = `/intelligence/reports/trendingGames/${uid}/${ver}`;
  history.push(url);
};
